import { TheWestSection } from '@news-mono/common'
import { metrics } from '@news-mono/component-library'
import { BaseClientConfig, publicationAdPageType } from '@news-mono/web-common'
import { ArticleLikeV4DTO } from '@west-australian-newspapers/publication-types'
import { layout } from '../../../App.routing'

export const getAmpArticleComposition = (
    article: ArticleLikeV4DTO,
    section: TheWestSection,
    config: BaseClientConfig,
) =>
    layout.composition({
        type: 'box',
        props: {
            containerWidth: metrics.thewest.siteMetrics.mainContentWidth,
            horizontalGutters: 'unset',
            verticalGutters: ['unset', 'unset'],
        },
        contentAreas: {
            main: [
                layout.component({
                    type: 'amp-sticky-ad-unit',
                    props: {
                        slot: {
                            id: 'amp-article-sticky-footer',
                            size: 'leaderboard',
                            pageType: publicationAdPageType[article.kind],
                        },
                    },
                }),
                layout.component({
                    type: 'amp-google-analytics-four',
                    props: {
                        gaFourMeasureId: config.ampgGaFourMeasureId,
                        article,
                    },
                }),
                layout.component({
                    type: 'amp-sophi',
                    feature: 'sophi',
                    props: {
                        kind: article.kind,
                        sectionName: article.topics.primary.parent
                            ? article.topics.primary.parent?.id
                            : article.topics.primary.id,
                        primaryTopicId: article.topics.primary.id,
                        publicationDate: article.publicationDate,
                        publicationId: article.id,
                    },
                }),
                layout.component({
                    type: 'article',
                    props: {
                        meta: {
                            slug: article.slug,
                            kind: 'article',
                            inlinePublicationContent: [
                                {
                                    kind: 'ad',
                                    insertAfter: 3,
                                    content: [
                                        {
                                            noticePosition: 'below-center',
                                            hiddenUntilLoaded: true,
                                            slot: {
                                                id: 'amp-article-mrec-one',
                                                size: 'mobileMrec',
                                                pageType:
                                                    publicationAdPageType[
                                                        article.kind
                                                    ],
                                            },
                                            adType: 'inline',
                                        },
                                    ],
                                },
                                {
                                    kind: 'sport-call-to-action',
                                    insertAfter: 6,
                                },
                                {
                                    kind: 'inline-taboola-amp',
                                    insertAfter: 6,
                                },
                            ],
                        },
                        dataDefinitionArgs: {
                            publicationId: article.id,
                        },
                        section,
                    },
                }),
                layout.component({
                    feature: 'taboola',
                    type: 'taboola',
                    props: {
                        taboolaContainerId: 'taboola-below-article-thumbnails',
                        locationType: 'article',
                    },
                }),
            ],
        },
    })
